import { Accordion, Box, Image } from '@chakra-ui/react';
import React from 'react';
import Logo from '../../assets/images/bicester_collection.png';
import Bicester from '../../assets/images/map/bicester.png';
import Fidanza from '../../assets/images/map/fidenza.png';
import Ingo from '../../assets/images/map/ingo.png';
import Kildare from '../../assets/images/map/kildare.png';
import LaRoca from '../../assets/images/map/laroca.png';
import LasRozas from '../../assets/images/map/lasrozas.png';
import LaVallee from '../../assets/images/map/lavallee.png';
import Maas from '../../assets/images/map/maas.png';
import Shanghai from '../../assets/images/map/shanghai.png';
import Wertheim from '../../assets/images/map/wertheim.png';
import Background from '../../assets/images/map_bg.png';
import MapAccordianItem from '../../components/common/MapAccordianItem';
import { MapProps } from '../../interfaces/components';

const MapMobile = ({ setActive }: MapProps) => {
  const goToLaRocaVillage = () => {
    window.InitiateExperience();
    window.GotoScene('lr_exterior_0');

    setTimeout(() => {
      setActive('laroca');
    }, 500);
  };

  const goToLaValleeVillage = () => {
    window.InitiateExperience();
    window.GotoScene('lv_village_0');

    setTimeout(() => {
      setActive('lavallee');
    }, 500);
  };

  const goToBicesterVillage = () => {
    window.InitiateExperience();
    window.GotoScene('bv_village_0');

    setTimeout(() => {
      setActive('bicester');
    }, 500);
  };

  const goToFidenzaVillage = () => {
    window.InitiateExperience();
    window.GotoScene('fv_village_0');

    setTimeout(() => {
      setActive('fidenza');
    }, 500);
  };

  return (
    <Box w="100%" h="100vh">
      <Image src={Background} w="100%" h="100%" objectFit="cover" />
      <Box position="absolute" top="30px" left="0px" zIndex={3} w="100%" h="100%">
        <Box display="flex" justifyContent="center" alignItems="center" py="5">
          <Image src={Logo} w="160px" h="45px" objectFit="contain" alt="bicester collection" />
        </Box>

        <Box w={['300px', '320px']} h={['65%', '70%']} overflowY="auto" scrollBehavior="smooth" mt="8">
          <Accordion allowToggle>
            <MapAccordianItem image={Bicester} name="BICESTER VILLAGE" onClick={goToBicesterVillage} />
            <MapAccordianItem image={LaRoca} name="LA ROCA VILLAGE" onClick={goToLaRocaVillage} />
            <MapAccordianItem image={LasRozas} name="LAS ROZAS VILLAGE" />
            <MapAccordianItem image={LaVallee} name="LA VALLEE VILLAGE" onClick={goToLaValleeVillage} />
            <MapAccordianItem image={Maas} name="MAASMECHELEN VILLAGE" />
            <MapAccordianItem image={Fidanza} name="FIDENZA VILLAGE" onClick={goToFidenzaVillage} />
            <MapAccordianItem image={Wertheim} name="WERTHEIM VILLAGE" />
            <MapAccordianItem image={Ingo} name="INGOLSTADT VILLAGE" />
            <MapAccordianItem image={Shanghai} name="BICESTER VILLAGE SUZHOU" />
            <MapAccordianItem image={Shanghai} name="BICESTER VILLAGE SHANGHAI" />
            <MapAccordianItem image={Kildare} name="KILDARE VILLAGE" />
          </Accordion>
        </Box>
      </Box>
    </Box>
  );
};

export default MapMobile;
